import { defineComponentMeta } from 'shared/src/utils';

export const HyperLocus = {};

defineComponentMeta(HyperLocus, {
  name: 'HyperLocus',
  description: 'The presence of an entity with this component marks \
the level as taking place in hyperspace. Stations will teleport after firing.'
});
